import { IApp } from '@/types/nuxt'
import refresh from '@/utils/refresh'

export default class GetRoomUseCase implements BaseUseCase {
  constructor(protected App: IApp) {}

  async execute(id: string) {
    try {
      await refresh(this.App)
      return await this.App.monitaroGateway.Room.GetRoom(id)
    } catch (exception: any) {
      this.App.logService.handle(exception)
    }
    return null
  }
}
